import { FC, Suspense } from 'react'

import { Outlet } from '@tanstack/react-router'

import { Stack } from '@forto-dev/phoenix-ui-core'
import { Layout, LayoutVariant } from '@forto-dev/phoenix-ui-core/ship'

import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { Navigation } from '@/fragments/navigation'
import { WidgetSkeleton } from '@/fragments/widgetSkeleton'

import { NotificationPaginationContextProvider } from './hooks/NotificationPaginationContextProvider'
import { NotificationSortContextProvider } from './hooks/NotificationSortContextProvider'
import { NotificationsSidebar } from './list/sidebar'
import { NotificationsTitle } from './list/title'

export const Notifications: FC = () => {
  return (
    <NotificationPaginationContextProvider>
      <NotificationSortContextProvider>
        <Layout
          type={LayoutVariant.Notification}
          header={<Header />}
          navigation={<Navigation />}
          title={<NotificationsTitle />}
          sidebar={
            <Suspense fallback={<WidgetSkeleton count={3} />}>
              <NotificationsSidebar />
            </Suspense>
          }
          main={
            // Note: The actual scrolling is done by the `main` section, so this 1px height with overflow:visible
            // is necessary to prevent the whole page from scrolling.
            // It is only at md size sine below that the mobile view kicks in, where the entire page is scrollable again.
            // TODO: Remove this once we have a better solution
            // eslint-disable-next-line react/forbid-dom-props
            <div className="overflow-visible md:h-px">
              <Outlet />
              <Stack gap={16}>
                <Stack />
                <Stack />
              </Stack>
            </div>
          }
          footer={<Footer />}
        />
      </NotificationSortContextProvider>
    </NotificationPaginationContextProvider>
  )
}
